import { FormInstance } from "antd";
import { FloatNumberInput } from "../../../../components/FloatNumberInput";
import { transformToFloat } from "../../../../lib/transformToFloat";
import { usePercentageRule } from "../../../../lib/hooks/usePercentageRule";
import { useMemo } from "react";
import { Rule } from "antd/es/form";

type TAmountInputProps = {
  isDollarInput: boolean;
  form: FormInstance;
};

export const AmountInput = ({ isDollarInput, form }: TAmountInputProps) => {
  const { percentageRules } = usePercentageRule();

  const amountRules: Rule[] = useMemo(
    () => [
      {
        type: "number",
        transform: transformToFloat,
        max: 99999,
        validateTrigger: "onSubmit",
      },
      {
        required: true,
      },
    ],
    [],
  );

  return (
    <div className="amount-inputs-wrapper">
      {isDollarInput ? (
        <FloatNumberInput
          name="amount"
          label="Amount"
          form={form}
          className="amount-input-wrapper"
          includeThousandsSeparator
          rules={amountRules}
        />
      ) : (
        <FloatNumberInput
          name="percentage"
          label="Percent"
          form={form}
          prefix="%"
          decimalLimit={4}
          className="amount-input-wrapper"
          rules={percentageRules}
        />
      )}
    </div>
  );
};
